import React from 'react'

import FacebookShareButton from 'react-share/lib/FacebookShareButton'
import GooglePlusShareButton from 'react-share/lib/GooglePlusShareButton'
import TwitterShareButton from 'react-share/lib/TwitterShareButton'
import EmailShareButton from 'react-share/lib/EmailShareButton'

import FacebookIcon from 'react-share/lib/FacebookIcon'
import TwitterIcon from 'react-share/lib/TwitterIcon'
import GooglePlusIcon from 'react-share/lib/GooglePlusIcon'
import EmailIcon from 'react-share/lib/EmailIcon'

import withStyles from '@material-ui/core/styles/withStyles'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import Divider from '@material-ui/core/Divider'
import TextField from '@material-ui/core/TextField'
import CircularProgress from '@material-ui/core/CircularProgress'
import Word from '../../containers/Common/Word';
import { WID, getWord } from '../../constants/Language';
import { useContext } from 'react'
import { SettingsContext } from '../../Parts/Settings'
import { useEffect } from 'react'
import { useState } from 'react'

import clipboard from 'clipboard'

const styles = theme => ({
  share : {
    verticalAlign: 'top',
    display: 'inline-block',
    margin: theme.spacing.unit / 2,
    textAlign: 'center',
    cursor: 'pointer',
  },
  circularProgress: {
    textAlign: 'center',
  },
  dialogContent: {
    textAlign: 'center',
  },
  shortURLCopy: {
    paddingTop: '30px',
    textAlign: 'center'
  },
})

const ShareDialog = (props) => {
  const { classes, theme, open, url } = props

  const [isInitialized, setIsInitialized] = useState(false)
  
  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const handleClose = () => {
    if (props.onClose) {
      props.onClose()
    }
  }

  const handleEnter = () => {
    if (props.onEnter) {
      props.onEnter()
    }
  }

  const handleEntering = () => {
    if (props.onEntering) {
      props.onEntering(props.url)
    }
  }

  const handleExited = () => {
    if (props.onExited) {
      props.onExited()
    }
  }

  useEffect(() => {
    if (!isInitialized) {
      var cb = new clipboard('.copy-button')
      cb.on('success', (e) =>{
        e.clearSelection()
        props.notify(getWord(WID.SHARE_DIALOG.NOTIFY.MESSAGE_SUCCESS_COPY_THE_SHORT_URL, language))
        })
        cb.on('error', (e) => {
          props.notify(getWord(WID.SHARE_DIALOG.NOTIFY.MESSAGE_FAILED_COPY_THE_SHORT_URL, language))
      })
      setIsInitialized(true)
    }
  }, [isInitialized])

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        onEnter={handleEnter}
        onEntering={handleEntering}
        onExited={handleExited}
      >
        <DialogTitle><Word wid={WID.SHARE_DIALOG.DIALOG_TITLE}/></DialogTitle>
        {url === '' ? (
          <div className={classes.circularProgress}>
            <CircularProgress className={classes.progress} />
          </div>
        ) : (
          <React.Fragment>
            <DialogContent className={classes.dialogContent}>
              <div className={classes.share}>
                <FacebookShareButton url={url} hashtags={['RenjuPortal']}>
                  <FacebookIcon size={42} round/>
                </FacebookShareButton>
              </div>
              <div className={classes.share}>
                <TwitterShareButton url={url} hashtags={['RenjuPortal']}>
                  <TwitterIcon size={42} round/>
                </TwitterShareButton>
              </div>
              <div className={classes.share}>
                <GooglePlusShareButton url={url}>
                  <GooglePlusIcon size={42} round/>
                </GooglePlusShareButton>
              </div>
              <div className={classes.share}>
                <EmailShareButton url={url}>
                  <EmailIcon size={42} round/>
                </EmailShareButton>
              </div>
            </DialogContent>
            <Divider/>
            <DialogContent className={classes.shortURLCopy}>
              <TextField label="URL" id="short-url" value={url}/>
              {(clipboard !== undefined && clipboard.isSupported()) && (
                <Button
                  variant="contained"
                  style={{margin: theme.spacing.unit}}
                  disabled={url === ''}
                  color="primary"
                  autoFocus
                  className={'copy-button'}
                  data-clipboard-target="#short-url"
                >
                  Copy
                </Button>
              )}
            </DialogContent>
          </React.Fragment>
        )}
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(ShareDialog)


// WEBPACK FOOTER //
// ./src/components/Common/ShareDialog.js